import apolloClient from "../apolloClient";
import { CONNECT_APP } from "./graphql";

class StoreService {
	async connect() {
		const { data } = await apolloClient.mutate({
			mutation: CONNECT_APP,
		});
		return data.connectApp.key;
	}
}

export default new StoreService();
